import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSuperAdminOrganization } from "../../../context/SuperAdmin/OrganizationContext";
import {
  iDataOrganizacion,
  OrgColumn,
} from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import ProfileRowOrg from "./ProfileRowOrg";
import SingleOrgPagination from "./SingleOrgPagination";
import SortedHeaderCell from "./SortedHeaderCell";

export const OrganizationsTable = () => {
  const {
    handleChangePage,
    handleChangeRowsPerPage,
    filteredOrgs,
    page,
    rowsPerPage,
    isLoadingOrgs,
  } = useSuperAdminOrganization();

  const [orderBy, setOrderBy] = useState<OrgColumn | null>(null);
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");
  const [sortedOrganizations, setSortedOrganizations] = useState<
    iDataOrganizacion[]
  >([]);

  // Función para manejar el cambio de orden
  const handleSort = (column: OrgColumn) => {
    if (orderBy === column) {
      setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(column);
      setOrderDirection("asc");
    }
  };

  useEffect(() => {
    if (filteredOrgs.length > 0 && !isLoadingOrgs) {
      setSortedOrganizations(
        [...filteredOrgs].sort((a, b) => {
          if (!orderBy) return 0;
          let aValue;
          let bValue;
          switch (orderBy) {
            case "fecha":
              aValue = new Date(a.updated_at);
              bValue = new Date(b.updated_at);
              break;
            case "estado":
              aValue = a.estado;
              bValue = b.estado;
              break;
            case "pais":
              aValue = a.pais.toLowerCase();
              bValue = b.pais.toLowerCase();
              break;
            default:
              return 0;
          }

          if (aValue < bValue) return orderDirection === "asc" ? -1 : 1;
          if (aValue > bValue) return orderDirection === "asc" ? 1 : -1;
          return 0;
        })
      );
    }
  }, [filteredOrgs, orderBy, orderDirection]);
  
  return (
    <>
      <TableContainer
        sx={{
          width: "100%",
          margin: "auto",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
          <TableHead sx={{ height: 20 }}>
            <TableRow>
              <StyledTableCell>N°</StyledTableCell>
              <StyledTableCell>Nombre de organización</StyledTableCell>
              <SortedHeaderCell
                label="País"
                column="pais"
                handleSort={handleSort}
                orderBy={orderBy}
                orderDirection={orderDirection}
              />
              <SortedHeaderCell
                label="Fecha de actualización"
                column="fecha"
                handleSort={handleSort}
                orderBy={orderBy}
                orderDirection={orderDirection}
              />
              <SortedHeaderCell
                label="Estado"
                column="estado"
                handleSort={handleSort}
                orderBy={orderBy}
                orderDirection={orderDirection}
              />
              <StyledTableCell align="center">Acciones</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedOrganizations
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((o, index) => (
                <ProfileRowOrg key={o.id_organizacion} index={index} org={o} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <SingleOrgPagination
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        count={filteredOrgs.length}
        options={[5, 10, 25, 50]}
      />
    </>
  );
};
